const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

function dueTimestamp(value?: string | null): number | null {
  const raw = String(value || '').trim();
  if (!raw) return null;

  const dateOnly = DATE_ONLY_RE.exec(raw);
  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    const yearValue = Number(year);
    const monthValue = Number(month);
    const dayValue = Number(day);
    // Date-only due dates are calendar promises, so they expire at local end-of-day.
    const endOfLocalDay = new Date(yearValue, monthValue - 1, dayValue, 23, 59, 59, 999);
    const ms = endOfLocalDay.getTime();
    if (
      !Number.isFinite(ms)
      || endOfLocalDay.getFullYear() !== yearValue
      || endOfLocalDay.getMonth() !== monthValue - 1
      || endOfLocalDay.getDate() !== dayValue
    ) {
      return null;
    }
    return ms;
  }

  const ms = new Date(raw).getTime();
  return Number.isFinite(ms) ? ms : null;
}

export function isWorkspaceDueDateOverdue(value?: string | null, nowMs = Date.now()): boolean {
  const ms = dueTimestamp(value);
  return ms !== null && ms < nowMs;
}
